module.exports = __webpack_public_path__ + "img/1441233276.17e69cac.jpg";